import {makeObservable, observable} from 'mobx';
import BlockObject from "./BlockObject";

export default class InstagramBlockObject extends BlockObject implements IInstagramBlockObj {

    blockUrl: string;
    links: Array<IInstagramLinkItem>;

    constructor(blockType: OrganizationType, initialBlockObj: IInstagramBlockObj | undefined) {
        super(blockType, initialBlockObj);
        this.setAttributes(initialBlockObj);
        makeObservable(this, {
            blockUrl: observable,
            links: observable,
        })
    }
}
